import { PureComponent } from "react";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import Picture from "/components/core/picture/picture-component";

import { componentStyles } from "./cluster-solutions-component.scss";

export default class ClusterSolutionsComponent extends PureComponent {
  render() {
    const { showDecorations, cta, selectedCluster } = this.props;

    return (
      <div className="cluster-solutions">
        <div className="signup-button-wrapper">
          <SignupFormComponent buttonColor={"brand-blue"} ctaText={cta} showDecorations={showDecorations} />
        </div>

        <div className="solutions-image-wrapper">
          <Picture className="solutions-image" src={selectedCluster.solutionsImage} />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}
